import React from 'react'

import { Form, Col, AsyncSelect } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

import { OperacionesIngGasConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as ProductoCrud from 'services/producto.service'
import * as CuentaContableService from 'services/cuentaContable.service'

import { ZariContext } from '_zari/context'

import operacionesIngresosGastos from 'constants/operacionesIngresosGastos'

const ProductoFormGroup = ({ iError, iTouched, iValue, updateStore, rowIndex, values, setValues }) => {

  const busquedaRef = React.useRef({})

  const __zariContext = React.useContext(ZariContext)

  const loadProductosSelect = (inputValue, resolve) => {
    ProductoCrud.obtenerAsSelect2Presupuesto({
      busqueda: inputValue
    }).then(({ data }) => {
      resolve(data)
    })
  }

  const actualizarTipoOperacion = (cuentaContable) => {
    CuentaContableService.getCuentasContablesPresupuestoNuevo(cuentaContable).then(({ data }) => {
      values.cuentaContable = data.value
      values.cuentaContableInfo = data.label
      values.cuentaContableTipoDocumento = data.tipoDocumento
      values.flagCentroCosto = data.flagCentroCosto
      values.esCuentaActivoFijo = data.esActivoFijo
      values.tipoSocio = data.tipoSocio
      values.moneda = data.moneda

      if (!data.value.startsWith('6') && !data.value.startsWith('9')) {
        values.tipoAfectacion = ''
      }

      setValues(values)

      setTimeout(() => {
        updateStore()
        KeyEventUtil.leaveOnKeyEvent(data.flagCentroCosto ? `select-det-centroCostoNivel1-${rowIndex}` : `input-det-importeDebe-${rowIndex}`)
      }, 200)
    }).catch(({ data: { error } }) => {
      __zariContext.snack('error', error)
    })
  }

  const onChangeProductoHandler = _idProductoPresentacion => {
    ProductoCrud.getProducto_Ventas(_idProductoPresentacion.value).then(({ data }) => {
      values.cuentaContableCompra = data.cuentaContableCompra
      values.cuentaContableVenta = data.cuentaContableVenta
      values.nombreProducto = data.nombreProducto.concat(` - ${data.nombreUnidadDeMedida}`)
      values._idProductoPresentacion = _idProductoPresentacion.value

      if (data.flagVenta && !data.flagCompra) {
        values.tipoOperacion = operacionesIngresosGastos.INGRESOS
        actualizarTipoOperacion(data.cuentaContableVenta)
      } else if (!data.flagVenta && data.flagCompra) {
        values.tipoOperacion = operacionesIngresosGastos.GASTOS
        actualizarTipoOperacion(data.cuentaContableCompra)
      }

      setValues(values)
    })

    setTimeout(() => {
      updateStore()
    }, 200)
  }

  const clickClear = () => {
    values.cuentaContable = ''
    values.cuentaContableInfo = ''
    values.cuentaContableTipoDocumento = ''
    values.flagCentroCosto = false
    values.esCuentaActivoFijo = false
    values.tipoSocio = ''
    values.moneda = ''
    values.tipoOperacion = OperacionesIngGasConstant.SELECCIONAR
    values._idProducto = ""
    values.nombreProducto = ""
    setValues(values)
    setTimeout(() => {
      updateStore()
      KeyEventUtil.leaveOnKeyEvent(`productoSelect-${rowIndex}`)
    }, 200)
  }

  return (
    <Form.Group>
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup id={`input-producto-data-${rowIndex}`} iValue={iValue} clickClear={clickClear} />
        ) : (
          <AsyncSelect
            ref={busquedaRef}
            selectId='productoSelect'
            loadOptions={loadProductosSelect}
            onChange={onChangeProductoHandler}
          />
          // <AsyncSelect selectId={`productoSelect-${rowIndex}`} loadOptions={loadProductosSelect} onChange={onChangeProductoHandler} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProductoFormGroup)
